import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RegistrationRoutingModule } from './registration-routing.module';
import { RegWorkflowMappingService } from '../core/services/reg-workflow-mapping.service';
import { RegistrationService } from '../core/services/registration.service';
import { OrderCompleteComponent } from './pages/order-complete/order-complete.component';
import { OrderSummaryComponent } from './pages/order-summary/order-summary.component';
import { ProofOfIdentitySelectionSummaryComponent } from './pages/proof-of-identity/proof-of-identity-selection-summary/proof-of-identity-selection-summary.component';
import { ProofOfIdentityTestPurposeComponent } from './pages/proof-of-identity/proof-of-identity-test-purpose/proof-of-identity-test-purpose.component';
import { ProofOfIdentityComponent } from './pages/proof-of-identity/proof-of-identity.component';
import { ScoreReportComponent } from './pages/score-report/score-report.component';
import { StudyMaterialsComponent } from './pages/study-materials/study-materials.component';
import { TestSummaryComponent } from './pages/test-summary/test-summary.component';
import { RegistrationComponent } from './registration.component';
import { SharedModule } from '../shared/shared.module';
import { ProofOfIdentityFormComponent } from './pages/proof-of-identity/proof-of-identity-form/proof-of-identity-form.component';
import { BatchRegistrationSelectAccountsComponent } from './pages/business-account/batch-registration-select-accounts/batch-registration-select-accounts.component';
import { PhotoUploadComponent } from './pages/photo-upload/photo-upload.component';
import { ScannedDocumentUploadComponent } from './pages/scanned-document-upload/scanned-document-upload.component';
import { SelectedTestInfoComponent } from './pages/selected-test-info/selected-test-info.component';
import { StudyMaterialModalComponent } from './pages/study-materials/study-material-modal/study-material-modal.component';
import { SittingSelectionWebDeliveryComponent } from './pages/sitting-selection-web-delivery/sitting-selection-web-delivery.component';
import { BatchRegistrationSelectTestComponent } from './pages/business-account/batch-registration-select-test/batch-registration-select-test.component';
import { BatchRegistrationSelectSittingComponent } from './pages/business-account/batch-registration-select-sitting/batch-registration-select-sitting.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { SittingSelectionComponent } from './pages/sitting-selection/sitting-selection.component';
import { TestSelectionComponent } from './pages/test-selection/test-selection.component';
import { SittingListComponent } from './components/sitting-list/sitting-list.component';
import { PublicSittingsComponent } from './pages/sitting-selection/public-sittings/public-sittings.component';
import { LocationDropdownsComponent } from './pages/sitting-selection/public-sittings/location-dropdowns/location-dropdowns.component';
import { SittingTypeSelectionComponent } from './components/sitting-type-selection/sitting-type-selection.component';
import { BiometricConsentComponent } from './pages/biometric-consent/biometric-consent.component';
import { ApprovedPaymentComponent } from './pages/order-complete/approved-payment/approved-payment.component';
import { TestRegistrationReceiptComponent } from './pages/order-complete/test-registration-receipt/test-registration-receipt.component';
import { AccountModule } from '../account/account.module';




@NgModule({
  declarations: [
    RegistrationComponent,
    OrderCompleteComponent,
    OrderSummaryComponent,
    ProofOfIdentityComponent,
    ScoreReportComponent,
    StudyMaterialsComponent,
    TestSummaryComponent,
    ProofOfIdentitySelectionSummaryComponent,
    ProofOfIdentityTestPurposeComponent,
    ProofOfIdentityFormComponent,
    BatchRegistrationSelectAccountsComponent,
    StudyMaterialModalComponent,
    PhotoUploadComponent,
    ScannedDocumentUploadComponent,
    SelectedTestInfoComponent,
    StudyMaterialModalComponent,
    SittingSelectionWebDeliveryComponent,
    SittingListComponent,
    SelectedTestInfoComponent,
    SittingSelectionComponent,
    BatchRegistrationSelectTestComponent,
    BatchRegistrationSelectSittingComponent,
    TestSelectionComponent,
    LocationDropdownsComponent,
    PublicSittingsComponent,
    SittingTypeSelectionComponent,
    BiometricConsentComponent,
    ApprovedPaymentComponent,
    TestRegistrationReceiptComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RegistrationRoutingModule,
    SharedModule,
    NgxIntlTelInputModule,
    NgbModule,
    AccountModule
  ],
  providers: [
    RegWorkflowMappingService,
    RegistrationService
  ]
})
export class RegistrationModule { }
